// extracted by mini-css-extract-plugin
export var backdropBlur = "_6x-0";
export var body = "_6x-5";
export var bodyScroll = "_6x-6";
export var columnFooter = "_6x-7";
export var columnFooterFlush = "_6x-8";
export var contentColumn = "_6x-4";
export var frame = "_6x-3";
export var heroContent = "_6x-c";
export var heroOverlay = "_6x-b";
export var image = "_6x-a";
export var imageWrapper = "_6x-9";
export var modal = "_6x-1";
export var modalMain = "_6x-2";
export var productHeader = "_6x-d";
export var productHeaderIcon = "_6x-e";
export var productHeaderName = "_6x-f";
export var progressIndicator = "_6x-g";